import { useEffect } from 'react';

import { UseFormUnregister } from 'react-hook-form';

import { FormFields } from '../components/AdvancedCalculationTool/AdvancedCalculationTool.schema';

type Props = {
  hasSolarPanels: boolean | undefined;
  onlySingleFuelElectricity: boolean | undefined;
  isUsageKnown: string | undefined;
  hasDoubleMeter: boolean | undefined;
  unregister: UseFormUnregister<FormFields>;
};

export const useCulculationToolFormFieldWatcher = ({
  hasSolarPanels,
  onlySingleFuelElectricity,
  isUsageKnown,
  hasDoubleMeter,
  unregister,
}: Props) => {
  useEffect(() => {
    if (!hasSolarPanels) {
      unregister('solarPanelsOutput');
    }
  }, [hasSolarPanels, unregister]);

  useEffect(() => {
    if (onlySingleFuelElectricity) {
      unregister('usageGas');
    }
  }, [onlySingleFuelElectricity, unregister]);

  useEffect(() => {
    if (isUsageKnown === 'false') {
      unregister(['usageElectricityHigh', 'usageElectricityLow', 'usageGas']);
    }
  }, [isUsageKnown, unregister]);

  useEffect(() => {
    if (!hasDoubleMeter) {
      unregister('usageElectricityLow');
    }
  }, [hasDoubleMeter, unregister]);
};
